import {default as BaseInitializer} from "@/ts/base/Components/Blocks/Initializer";
import PricingTable from "./PricingTable";
import WoocommerceSlider from "./WoocommerceSlider";

class Initializer extends BaseInitializer {

	constructor() {
		super();

		this.initButtons();
	}

	getBlocks() {
		let blocks = super.getBlocks();
		blocks[".thee-block-pricing-table"] = PricingTable;
		blocks[".thee-block-woocommerce-slider"] = WoocommerceSlider;

		return blocks;
	}

	protected initButtons() {
		let wooButtons;

		wooButtons = document.querySelectorAll('.woocommerce .button');

		for (let i = 0; i < wooButtons.length; i++) {
			let text = wooButtons[i].innerHTML;

			text = text.toLowerCase();
			text = text.replace(/(?:^|\s)\S/g, (match) => {
				return match.toUpperCase();
			});

			wooButtons[i].innerHTML = "<span>" + text + "<i class='fas fa-angle-right'></i></span>";
			wooButtons[i].classList.remove('button');
			wooButtons[i].classList.add('btn');

			if (wooButtons[i].classList.contains('alt')) {
				wooButtons[i].classList.add('btn-secondary');
			}
			else {
				wooButtons[i].classList.add('btn-primary');
			}
		}
	}
}

export default Initializer;
